import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { PackageExpenseServices } from '../services/packageexpenseServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { makePersistable, stopPersisting } from 'mobx-persist-store';


export default class PackageExpenseStore {    

    
  rootStore;
    packageExpenses = [];
    packageExpense = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          config: observable,
          setConfig: action,

          packageExpenses: observable,
          packageExpense: observable,
          getAll: action,          
          reset: action,
          save: action,
          remove: action,            
      });
      makePersistable(this, { name: 'packageExpenseStore', properties: ['config'], storage: window.localStorage });

    }          

    remove = async (id) => {
        try {
            const data = await PackageExpenseServices.delete(id);
            runInAction(() => { toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("packageExpense") })}`);});
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/});
        }
    }

    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await PackageExpenseServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("packageExpense") })}`);
                });
            } catch (error) {}
        } else {
            try {
                const data = await PackageExpenseServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("packageExpense") })}`);
                    this.reset();                    
                });
            } catch (error) {}
        }
    };

    reset = () => {        
        runInAction(() => this.packageExpense = {});
    }
    
    
    setConfig = (prop, c) => { this.config[prop] = c; }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await PackageExpenseServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.packageExpenses = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.packageExpenses = [];
            });
        }
    }

    getAll = async (page, filter, sort) => {
        try {
            const data = await PackageExpenseServices.getAll({ page: page, filter: filter, sort: sort });
            runInAction(() => { this.packageExpenses = data;})
        }
        catch (error) {
            runInAction(() => { this.packageExpenses = [];});
        }
    }    

    getById = async (id) => {
        try {
            const data = await PackageExpenseServices.getById(id);
            runInAction(() => { this.packageExpense = data;});
        } catch (error) {
            runInAction(() => { this.packageExpense = {};})
        }
    };

    
}